import { render } from "./Departament_Integrimi.vue?vue&type=template&id=0aaf59a2&scoped=true"
import script from "./Departament_Integrimi.vue?vue&type=script&lang=js"
export * from "./Departament_Integrimi.vue?vue&type=script&lang=js"

import "./Departament_Integrimi.vue?vue&type=style&index=0&id=0aaf59a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaf59a2"]])

export default __exports__